import { render, staticRenderFns } from "./leftBoard.vue?vue&type=template&id=206d2f96&scoped=true"
import script from "./leftBoard.vue?vue&type=script&lang=js"
export * from "./leftBoard.vue?vue&type=script&lang=js"
import style0 from "./leftBoard.vue?vue&type=style&index=0&id=206d2f96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206d2f96",
  null
  
)

export default component.exports